"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.layer3 = exports.layer2 = exports.layer1 = exports.register = exports.get = exports.dataMap = exports.dataList = exports.EVoyageTile = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var EVoyageTile;
(function (EVoyageTile) {
    EVoyageTile[EVoyageTile["Default"] = -1] = "Default";
    EVoyageTile[EVoyageTile["Null2"] = 0] = "Null2";
    EVoyageTile[EVoyageTile["SquareBottom"] = 1] = "SquareBottom";
    EVoyageTile[EVoyageTile["CheckerBottom"] = 2] = "CheckerBottom";
    EVoyageTile[EVoyageTile["Square"] = 3] = "Square";
    EVoyageTile[EVoyageTile["Triangle"] = 4] = "Triangle";
    EVoyageTile[EVoyageTile["Checker"] = 5] = "Checker";
    EVoyageTile[EVoyageTile["Floor"] = 6] = "Floor";
    EVoyageTile[EVoyageTile["ShadeBottom"] = 7] = "ShadeBottom";
    EVoyageTile[EVoyageTile["Door"] = 8] = "Door";
    EVoyageTile[EVoyageTile["Fence"] = 9] = "Fence";
    EVoyageTile[EVoyageTile["FakeBottom"] = 10] = "FakeBottom";
    EVoyageTile[EVoyageTile["Chair"] = 11] = "Chair";
    EVoyageTile[EVoyageTile["Table"] = 12] = "Table";
    EVoyageTile[EVoyageTile["Null3"] = 100] = "Null3";
    EVoyageTile[EVoyageTile["Text"] = 101] = "Text";
    EVoyageTile[EVoyageTile["CrewSpawn"] = 102] = "CrewSpawn";
    EVoyageTile[EVoyageTile["System"] = 103] = "System";
    EVoyageTile[EVoyageTile["Elevator"] = 104] = "Elevator";
    EVoyageTile[EVoyageTile["Test"] = 105] = "Test";
    EVoyageTile[EVoyageTile["MedPad"] = 106] = "MedPad";
})(EVoyageTile = exports.EVoyageTile || (exports.EVoyageTile = {}));
var _default = {
    type: EVoyageTile.Default,
    layer: 2,
    frames: sprites_sidecar_1.sprites.voyTileCheckerFine1,
    canWalk: false,
    colors: voyageColors_sidecar_1.voyageColors.all,
    includesText: false,
    isNull: false,
    pathfindPenalty: 0,
};
exports.dataList = [];
exports.dataMap = [];
var dataType = 'voyage-tiles';
var get = function (type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetDataNum(dataType, exports.dataMap, type);
};
exports.get = get;
var register = function (data) {
    entitiesUtils_sidecar_1.entitiesUtils.genericRegisterDataNum(dataType, data, _default, exports.dataList, exports.dataMap);
};
exports.register = register;
exports.layer1 = [];
exports.layer2 = [];
exports.layer3 = [];
function registerAll() {
    exports.register({
        type: EVoyageTile.SquareBottom,
        frames: sprites_sidecar_1.sprites.voyTileSquareBottom,
        layer: 1,
        colors: [voyageColors_sidecar_1.voyageColors.g1],
        isNull: true,
    });
    exports.register({
        type: EVoyageTile.CheckerBottom,
        frames: sprites_sidecar_1.sprites.voyTileChecker1,
        layer: 1,
        colors: [voyageColors_sidecar_1.voyageColors.g2],
        //    isNull: true,
    });
    exports.register({
        type: EVoyageTile.FakeBottom,
        frames: sprites_sidecar_1.sprites.voyTileSquare,
        layer: 1,
        colors: [voyageColors_sidecar_1.voyageColors.floor],
        //    isNull: true,
    });
    exports.register({
        type: EVoyageTile.ShadeBottom,
        frames: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.voyTileTri1)), __read(sprites_sidecar_1.sprites.voyTileTri2)), __read(sprites_sidecar_1.sprites.voyTileTri3)), __read(sprites_sidecar_1.sprites.voyTileTri4)),
        colors: [voyageColors_sidecar_1.voyageColors.g2],
        layer: 1,
    });
    exports.register({
        type: EVoyageTile.Null2,
        frames: sprites_sidecar_1.sprites.voyTileNull,
        isNull: true,
    });
    exports.register({
        type: EVoyageTile.Square,
        frames: sprites_sidecar_1.sprites.voyTileSquare,
        colors: [
            voyageColors_sidecar_1.voyageColors.g2,
            voyageColors_sidecar_1.voyageColors.g3,
            voyageColors_sidecar_1.voyageColors.g4,
            voyageColors_sidecar_1.voyageColors.purple,
        ],
    });
    exports.register({
        type: EVoyageTile.Floor,
        frames: sprites_sidecar_1.sprites.voyTileSquare,
        colors: [voyageColors_sidecar_1.voyageColors.floor],
        canWalk: true,
    });
    exports.register({
        type: EVoyageTile.Door,
        frames: __spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.voyTileFence1A)), __read(sprites_sidecar_1.sprites.voyTileFence1B)),
        colors: [voyageColors_sidecar_1.voyageColors.g4],
        canWalk: true,
    });
    exports.register({
        type: EVoyageTile.Chair,
        frames: sprites_sidecar_1.sprites.voyTileChair,
        colors: [voyageColors_sidecar_1.voyageColors.g3],
        canWalk: true,
    });
    exports.register({
        type: EVoyageTile.Table,
        frames: sprites_sidecar_1.sprites.voyTileTable,
        colors: [voyageColors_sidecar_1.voyageColors.g3],
    });
    exports.register({
        type: EVoyageTile.Triangle,
        frames: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.voyTileTri1)), __read(sprites_sidecar_1.sprites.voyTileTri2)), __read(sprites_sidecar_1.sprites.voyTileTri4)), __read(sprites_sidecar_1.sprites.voyTileTri3)),
    });
    exports.register({
        type: EVoyageTile.Fence,
        frames: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.voyTileFence1A)), __read(sprites_sidecar_1.sprites.voyTileFence1B)), __read(sprites_sidecar_1.sprites.voyTileFence2A)), __read(sprites_sidecar_1.sprites.voyTileFence2B)), __read(sprites_sidecar_1.sprites.voyTileFence3A)), __read(sprites_sidecar_1.sprites.voyTileFence3B)),
        colors: [voyageColors_sidecar_1.voyageColors.g2, voyageColors_sidecar_1.voyageColors.g3],
    });
    exports.register({
        type: EVoyageTile.Null3,
        frames: sprites_sidecar_1.sprites.voyTileNull,
        layer: 3,
        isNull: true,
    });
    exports.register({
        type: EVoyageTile.Text,
        frames: sprites_sidecar_1.sprites.voyTileSpecialT,
        layer: 3,
        colors: [voyageColors_sidecar_1.voyageColors.purple],
        includesText: true,
    });
    exports.register({
        type: EVoyageTile.CrewSpawn,
        frames: sprites_sidecar_1.sprites.voyTileSpecialC,
        layer: 3,
        colors: [voyageColors_sidecar_1.voyageColors.purple],
    });
    exports.register({
        type: EVoyageTile.System,
        frames: sprites_sidecar_1.sprites.voyTileStation,
        layer: 3,
        colors: [voyageColors_sidecar_1.voyageColors.purple],
        includesText: true,
        pathfindPenalty: 4,
    });
    exports.register({
        type: EVoyageTile.Elevator,
        frames: sprites_sidecar_1.sprites.voyTileSpecialE,
        layer: 3,
        colors: [voyageColors_sidecar_1.voyageColors.purple],
        includesText: true,
        pathfindPenalty: 5,
    });
    exports.register({
        type: EVoyageTile.MedPad,
        frames: [sprites_sidecar_1.sprites.voyTilePluses[1]],
        layer: 3,
        colors: [voyageColors_sidecar_1.voyageColors.purple],
        includesText: true,
    });
    exports.register({
        type: EVoyageTile.Test,
        frames: sprites_sidecar_1.sprites.voyTileSpecialTest,
        layer: 3,
        colors: [voyageColors_sidecar_1.voyageColors.purple],
        includesText: true,
    });
    exports.layer1.push.apply(exports.layer1, __spreadArray([], __read(imports_1.l.filter(exports.dataList, function (c) { return c.layer === 1; }))));
    Object.freeze(exports.layer1);
    exports.layer2.push.apply(exports.layer2, __spreadArray([], __read(imports_1.l.filter(exports.dataList, function (c) { return c.layer === 2; }))));
    Object.freeze(exports.layer2);
    exports.layer3.push.apply(exports.layer3, __spreadArray([], __read(imports_1.l.filter(exports.dataList, function (c) { return c.layer === 3; }))));
    Object.freeze(exports.layer3);
}
exports.registerAll = registerAll;
